import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Dumbbell, Users, Heart, Apple, UserCheck, Scale, Brain, Zap, Target, Trophy, Star, Shield } from "lucide-react";
import { uploadSrcSet, srcSetFallback } from "@/lib/imgVariants";
import axios from "axios";

const API = `/api`;

const iconMap = { Dumbbell, Users, Heart, Apple, UserCheck, Scale, Brain, Zap, Target, Trophy, Star, Shield };

const fallbackServices = [
  { id: "musculacao", icon: "Dumbbell", title: "Musculação", description: "Equipamentos de última geração para desenvolvimento muscular, força e definição.", image: "/images/services/musculacao.jpg" },
  { id: "aulas", icon: "Users", title: "Aulas de Grupo", description: "Mais de 100 aulas semanais: spinning, body pump, zumba, HIIT e muito mais.", image: "/images/services/aulas.jpg" },
  { id: "pilates", icon: "Heart", title: "Pilates", description: "Fortalece o core, melhora a postura e aumenta a flexibilidade.", image: "/images/services/pilates.jpg" },
  { id: "personal", icon: "UserCheck", title: "Personal Training", description: "Treino 100% personalizado com profissionais certificados.", image: "/images/services/personal.jpg" },
  { id: "nutricao", icon: "Apple", title: "Nutrição", description: "Planos alimentares personalizados para os teus objetivos.", image: "/images/services/nutricao.jpg" },
];

export const Services = () => {
  const [services, setServices] = useState(fallbackServices);

  useEffect(() => {
    axios.get(`${API}/content/services`)
      .then((res) => {
        if (res.data && res.data.length > 0) setServices(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="servicos" className="py-20 lg:py-28 bg-[#FAF8F5]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="text-[#FED601] text-sm font-bold uppercase tracking-widest">
            Os Nossos Serviços
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-[#1A1A1A] mt-2 mb-4">
            Tudo Para o <span className="text-[#FED601]">Teu Sucesso</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Dumbbell;
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`group relative overflow-hidden rounded-xl ${
                  index === 0 ? "md:col-span-2 lg:col-span-1 lg:row-span-2" : ""
                }`}
                data-testid={`service-card-${service.id}`}
              >
                <div className={`relative ${index === 0 ? "h-full min-h-[300px]" : "h-64"} overflow-hidden`}>
                  <img
                    src={service.image}
                    srcSet={uploadSrcSet(service.image)}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    onError={srcSetFallback}
                    alt={service.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-[#FED601] rounded-lg flex items-center justify-center">
                        <IconComponent size={20} className="text-black" />
                      </div>
                      <h3 className="text-xl font-bold text-white">{service.title}</h3>
                    </div>
                    <p className="text-gray-200 text-sm">{service.description}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
